import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import FloatingButtons from '../components/FloatingButtons/FloatingButtons';
import ProductCard from '../components/Products/ProductCard';
import { newArrivals, featuredCollection, specialOne, highlights } from '../data/products';

const Products = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const section = searchParams.get('section') || 'new-arrivals';

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [section]);

  // Get products based on section
  const getProducts = () => {
    switch (section) {
      case 'new-arrivals':
        return newArrivals;
      case 'featured':
        return featuredCollection;
      case 'special-one':
        return specialOne;
      case 'highlights-birthday':
        return highlights.birthday;
      case 'highlights-anniversary':
        return highlights.anniversary;
      case 'highlights-baby-shower':
        return highlights.babyShower;
      case 'highlights-gifting':
        return highlights.gifting;
      default:
        return newArrivals;
    }
  };

  const getSectionTitle = () => {
    switch (section) {
      case 'new-arrivals':
        return 'New Arrivals';
      case 'featured':
        return 'Featured Collection';
      case 'special-one':
        return 'Special One';
      case 'highlights-birthday':
        return 'This Week Highlights - Birthday';
      case 'highlights-anniversary':
        return 'This Week Highlights - Anniversary';
      case 'highlights-baby-shower':
        return 'This Week Highlights - Baby Shower';
      case 'highlights-gifting':
        return 'This Week Highlights - Gifting';
      default:
        return 'Products';
    }
  };

  const products = getProducts();
  const title = getSectionTitle();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#8B1538] mb-8 sm:mb-12">
          {title}
        </h1>

        {products.length === 0 ? (
          <div className="text-center py-12 sm:py-20">
            <p className="text-gray-500 text-lg sm:text-xl">
              No products found in this section.
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-6">
            {products.map((product) => (
              <div
                key={product.id}
                className="w-full cursor-pointer"
                onClick={() => navigate(`/product/${product.id}`)}
              >
                <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300">
                  <div className="relative aspect-square overflow-hidden bg-gray-100">
                    <img
                      src={product.image}
                      alt={product.title}
                      loading="lazy"
                      decoding="async"
                      className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                    />
                    <div className="absolute top-2 left-2 text-xs font-semibold text-gray-600 opacity-50">
                      PartyNestt
                    </div>
                  </div>
                  <div className="p-3 sm:p-4">
                    <h3 className="text-xs sm:text-base font-medium text-gray-800 line-clamp-2 min-h-[2rem] sm:min-h-[2.5rem]">
                      {product.title}
                    </h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default Products;

